import React from "react";
import "./competencies.css";
import Separator from "../../common/separator";
import { CompetenciesData } from "../../data/competencies";
import CompetencyCard from "./competency-card";

function Competencies() {
  const data = CompetenciesData;
  return (
    <div className="competencies">
      <Separator />
      <label className="section-title">Core Competencies</label>
      <div className="competencies-grid">
        {data.map((item) => {
          return <CompetencyCard item={item} key={item.id} />;
        })}
      </div>
    </div>
  );
}

export default Competencies;
